import React from 'react';

import { Column } from 'native-base';

import type { IStackProps } from 'native-base';

const GridColumn = (props: IStackProps, ref?: any) => {
  return <Column flex="1" ref={ref} {...props} />;
};

export default React.memo(React.forwardRef(GridColumn));
